import React from 'react';
import './Careers.css';

const openings = [
  {
    title: 'Research Scientist — Neurochemical AI',
    type: 'Full-time / Remote',
    desc: 'Design and validate pharmacokinetic attention mechanisms for the AETHER architecture. Background in neuroscience, computational biology, or biochemistry preferred.'
  },
  {
    title: 'ML Engineer — Transformer Architecture',
    type: 'Full-time / Remote',
    desc: 'Build and optimize the cascading hierarchy: amino acid, precursor, neurotransmitter, and brain region attention heads. PyTorch experience required.'
  },
  {
    title: 'Computational Psychiatrist',
    type: 'Full-time / Remote',
    desc: 'Ground Aegis composite outputs in evidence-based psychiatry. Interpret three-prong biosensor + validated PRO + CAPS-5 ClinRO data in clinical context. Bridge our neurochemical language model to APA, VA/DoD CPG, and DSM-5-TR practice. MD or MD/PhD in psychiatry preferred, interest in AI-augmented clinical decision support.'
  },
  {
    title: 'Frontend Engineer',
    type: 'Full-time / Remote',
    desc: 'Build the interfaces for AI-powered pharmaceutical intelligence tools. React, data visualization, and attention to craft.'
  }
];

function Careers() {
  return (
    <section className="careers">
      <div className="careers-inner">
        <div className="careers-intro reveal">
          <p className="careers-lead">
            Nexus Concordat builds AI that processes information the way biology does.
            We are looking for people who want to build things that have never existed before.
          </p>
          <p>
            We are a small team with three provisional patents, a working architecture,
            and a regulatory strategy. Every person here has direct impact on the product,
            the science, and the company.
          </p>
        </div>

        <div className="careers-grid">
          {openings.map((job, i) => (
            <div className="careers-card reveal" key={i}>
              <span className="careers-type">{job.type}</span>
              <h3>{job.title}</h3>
              <p>{job.desc}</p>
            </div>
          ))}
        </div>

        <div className="careers-cta reveal">
          <p>
            Interested? Send your background and what excites you about neurochemical AI to:
          </p>
          <a href="mailto:caelsereith@aetherprotocols.com" className="careers-email">
            caelsereith@aetherprotocols.com
          </a>
        </div>
      </div>
    </section>
  );
}

export default Careers;
